import { connectAgentActions } from '@/redux/slices';
import { getReduxStore } from '@/redux/store';
import subscribeToAgentEvents from './agentEvents-invisible';
import subscribeToContactEvents from './contactEvents-invisible';

const ccpContainerId = 'ccp-container';
/**
 * CCP initialization and Core events
 */
export default function () {
  const store = getReduxStore();
  // const { connect: ccpState } = store.getState();
  // if (ccpState.initialed) {
  //   return;
  // }

  console.debug('CDEBUG >> CCP initialization() - ccpContainerId:', ccpContainerId);
  // Connect information: Replace with your Connect Instance
  // const ccpUrl = 'https://anker-us-installer-outbound.my.connect.aws/connect/ccp-v2';
  // const ccpUrl = 'https://anker-de-installer-outbound.my.connect.aws/connect/ccp-v2';
  // const ccpUrl = 'https://gfuswest.my.connect.aws/connect/ccp-v2';
  const ccpUrl = 'https://anker-us-outbound.my.connect.aws/ccp-v2';
  const connectRegion = 'us-west-2';
  // const connectRegion = 'eu-central-1';

  //----------------Init CCP Start----------------------------
  try {
    connect.core.initCCP(document.getElementById(ccpContainerId) as HTMLElement, {
      ccpUrl: ccpUrl, // REQUIRED
      loginPopup: true, // optional, defaults to `true`
      loginPopupAutoClose: true, // optional, defaults to `false` - 关闭自动登录true
      loginOptions: {
        // optional, if provided opens login in new window
        autoClose: true, // optional, defaults to `false` - 关闭自动登录true
        height: 600, // optional, defaults to 578
        width: 400, // optional, defaults to 433
        top: 0, // optional, defaults to 0
        left: 0, // optional, defaults to 0
      },

      region: connectRegion, // REQUIRED for `CHAT`, optional otherwise
      softphone: {
        // optional, defaults below apply if not provided
        allowFramedSoftphone: true, // optional, defaults to false
        disableRingtone: false, // optional, defaults to false
        ringtoneUrl: './ringtone.mp3', // optional, defaults to CCP’s default ringtone if a falsy value is set
      },
      pageOptions: {
        // optional
        enableAudioDeviceSettings: true, // optional, defaults to 'false'
        enablePhoneTypeSettings: true, // optional, defaults to 'true'
      },
      ccpAckTimeout: 5000, //optional, defaults to 3000 (ms)
      ccpSynTimeout: 3000, //optional, defaults to 1000 (ms)
      ccpLoadTimeout: 10000, //optional, defaults to 5000 (ms)
    });
    connect.getLog().warn('CDEBUG >> CCP initialized');
  } catch (err) {
    console.error('initCCP', err);
  }
  connect.core.onInitialized(function () {
    console.log('on ccp Initialized ');
    store.dispatch(connectAgentActions.setCcpInitialed(true));
  });
  //----------------Init CCP Finished----------------------------

  // Subscribe to interface events when agent click on other contact tab
  // Event includes ContactID of contact selected
  connect.core.onViewContact(function (event) {
    console.debug("CDEBUG >> onViewContact() - Now Vieving contact ID: '" + event.contactId + "'");
  });

  // Subscribe to Contact events
  connect.contact(subscribeToContactEvents);
  // Subscribe to Agent events
  connect.agent(subscribeToAgentEvents);

  // Send information to the Connect Logger
  connect.getLog().info('CDEBUG >> CCP initialized and subscribed to events');
}
